import { create } from "zustand";

export const useMyTrainingStore = create((set, get) => ({
  myTrainings: [],
  loading: false,
  error: null,
  pagination: {
    page: 1,
    currentPage: 1,
    pageSize: 10,
    itemsPerPage: 10,
    total: 0,
    totalItems: 0,
    totalPages: 1,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  searchParams: {
    searchTerm: "",
    page: 1,
    pageSize: 10,
  },
  columnFilters: {},
  uniqueValues: {},
  isDetailDialogOpen: false,
  trainingToView: null,
  showArchived: false,
  listTab: "active",

  setMyTrainings: (myTrainings) => set({ myTrainings }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setPagination: (pagination) => set({ pagination }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),

  openDetailDialog: (training) => set({
    isDetailDialogOpen: true,
    trainingToView: training,
  }),

  closeDetailDialog: () => set({
    isDetailDialogOpen: false,
    trainingToView: null,
  }),

  toggleShowArchived: () => {
    set({
      showArchived: !get().showArchived,
      searchParams: { ...get().searchParams, page: 1 },
    });
  },

  setListTab: (listTab) => {
    set({
      listTab,
      searchParams: { ...get().searchParams, page: 1 },
    });
  },

  setSearchTerm: (searchTerm) => {
    set({
      searchParams: { ...get().searchParams, searchTerm, page: 1 },
    });
  },

  setCurrentPage: (page) => {
    set({ searchParams: { ...get().searchParams, page } });
  },

  setPageSize: (pageSize) => {
    set({ searchParams: { ...get().searchParams, pageSize, page: 1 } });
  },

  clearError: () => set({ error: null }),
}));
